import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.div`
  width: ${props => props.width}px;

  @media only screen and (max-width: 1480px) {
    width: 100%;
  }
`

const Chart = styled.div`
  width: 100%;
  height: 4px;
  display: flex;
  gap: 1px;

  span:first-of-type {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  span:last-of-type {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`

const Bar = styled.span`
  height: 100%;
  ${props => `
    width: ${props.width || '0px'};
    background-color: ${props.color || '#e5e5e5'};
 `}
`

const Labels = styled.div`
  margin-top: 4px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0 8px;
  white-space: nowrap;
`

const Label = styled.span`
  margin: 0;
  line-height: 20px;
  font-size: 12px;
  font-weight: 600;
  color: ${props => props.color || '#000'};
`

const StackChart = ({ width = 150, total = 0, data = [] }) => {
  const getBarWidth = (count, total) => `${Math.round(width * (count / total)) - 1}px`

  const bars = data.map((variable, idx) => (
    <Bar key={idx} width={getBarWidth(variable.count, total)} color={variable.color} />
  ))

  const labels = data
    .filter(variable => variable.label)
    .map((variable, idx) => (
      <Label key={idx} color={variable.color}>
        {variable.label}: {variable.count}
      </Label>
    ))

  return (
    <Container width={width}>
      <Chart>{bars}</Chart>
      {!!labels.length && <Labels>{labels}</Labels>}
    </Container>
  )
}

StackChart.propTypes = {
  width: PropTypes.number,
  total: PropTypes.number,
  data: PropTypes.object,
  color: PropTypes.string,
}

export default StackChart
